
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class OrderedCheckBox extends Vue {
   
   @Prop({required: true})
    text!: string;

    @Prop({required: true})
    order!: number;

    @Prop({required: true})
    check!: string;

    @Prop({default: 18})
    shiftmark!: number;

    @Prop({default: 0})
    shift!: number;

    @Prop({default: ''})
    inline!: string;

    @Prop({default: '-1rem'})
    boxMargin!: string;

    @Prop({default: 'checkbox'})
    checkbox!: string;


    public getCheck(){
        if(this.check=='?') return "&#63"
        else if(this.check) return "&#10003"
        return ""
    }
    public getShift(){
        const temp = -10+Number(this.shift)
        if(this.shift !=0) return  temp+ 'px'
        return '-10px'
    }
}
